// app/javascript/projects/components/header/CodesHeader.jsx

import React from 'react';
import { useParams } from 'react-router-dom';
import DropdownHeader from './DropdownHeader'
import {MenuItem} from 'ui'
import { useCodeExports } from '../../../hooks/exports/useCodeExports'

const CodesHeader = (props) => {
  const { projectID } = useParams();
  const projectId = projectID;
  
  const {
    exportWord,
    exportCsv,
    isExportingWord,
    isExportingCsv,
    isReady
  } = useCodeExports(projectId);

  const exportCodeBook = () => {
    if (isReady && !isExportingWord) {
      exportWord();
    }
  }

  const exportCodeBookCSV = () => {
    if (isReady && !isExportingCsv) {
      exportCsv();
    }
  }

  const dropdownOptions = [
    <MenuItem 
      eventKey="1" 
      onClick={exportCodeBook}
      disabled={!isReady || isExportingWord}
    >
      Export Codes as DOC
    </MenuItem>,
    <MenuItem 
      eventKey="2" 
      onClick={exportCodeBookCSV}
      disabled={!isReady || isExportingCsv}
    >
      Export Codes as CSV
    </MenuItem>
  ]

  return (
    <div>
      <DropdownHeader
        projectId={projectId}
        dropdownOptions={dropdownOptions}
        hasEditPermission={props.hasEditPermission}
        isActive={props.isActive}
        roleIsEdit={props.roleIsEdit}
        onRenew={props.onRenew}
        onShowCollabModal={props.onShowCollabModal}
        showCollabModal={props.showCollabModal}  
      >
        Codes
      </DropdownHeader>
    </div>
  )
}

export default CodesHeader;
